import { render, staticRenderFns } from "./wxtzheader.vue?vue&type=template&id=5b1042ed&scoped=true&"
import script from "./wxtzheader.vue?vue&type=script&lang=js&"
export * from "./wxtzheader.vue?vue&type=script&lang=js&"
import style0 from "./wxtzheader.vue?vue&type=style&index=0&id=5b1042ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1042ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1042ed')) {
      api.createRecord('5b1042ed', component.options)
    } else {
      api.reload('5b1042ed', component.options)
    }
    module.hot.accept("./wxtzheader.vue?vue&type=template&id=5b1042ed&scoped=true&", function () {
      api.rerender('5b1042ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxtzheader.vue"
export default component.exports